export default "__VITE_ASSET__Ceb3bTSx__"